import { Outlet, useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { SectionTabs } from '../../shared/ui/SectionTabs';
import { TopbarActions } from '../../shared/ui/TopbarSlot';
import { ROUTES } from '../../shared/config/routes';
import { useScheduledCount } from '../../features/publications-tabs/useScheduledCount';

/**
 * Раздел «Публикации». Вкладки вместо отдельных пунктов меню: внизу на
 * телефоне помещаются три раздела, и четвёртый выталкивал бы подписи.
 *
 * Ключевое различие первой и третьей: «Через InstaFarm» — журнал приложения
 * (что отправили отсюда), «Вся лента» — всё, что лежит в аккаунтах Instagram,
 * включая посты, сделанные вручную с телефона.
 */
export function PublicationsLayout(): JSX.Element {
  const navigate = useNavigate();
  const scheduledCount = useScheduledCount();

  return (
    <div className="flex flex-col gap-4">
      <TopbarActions>
        <Button onClick={() => navigate(ROUTES.PUBLICATION_NEW)}>
          <Plus className="h-4 w-4" />
          Новая публикация
        </Button>
      </TopbarActions>

      <SectionTabs
        tabs={[
          { to: ROUTES.PUBLICATIONS, label: 'Через InstaFarm', end: true },
          { to: `${ROUTES.PUBLICATIONS}/scheduled`, label: 'Отложенные', count: scheduledCount },
          { to: `${ROUTES.PUBLICATIONS}/feed`, label: 'Вся лента' },
          // Комментарии разбираются под нашими же публикациями — им место здесь.
          { to: ROUTES.PUBLICATIONS_COMMENTS, label: 'Комментарии' },
        ]}
      />

      <Outlet />
    </div>
  );
}
